import { Component, OnInit, Inject } from '@angular/core';
import { RteDialogRef, IRteListButtonItem, RTEAlertService } from 'rte-library';
import { MAT_DIALOG_DATA } from '@angular/material';
import { UploadedValuesConfirmConfig, UploadValuesConfirmed } from './uploaded-values-confirm.model';
import { Schema } from 'src/app/reports/shared/rte-form/schema/schema.model';
import { validateForm } from '../../../report/report.validation';

@Component({
  selector: 'app-uploaded-values-confirm-dialog',
  templateUrl: './uploaded-values-confirm-dialog.component.html',
  styleUrls: ['./uploaded-values-confirm-dialog.component.scss']
})
export class UploadedValuesConfirmDialogComponent implements OnInit {

  selected: UploadValuesConfirmed;

  listButtons: Array<IRteListButtonItem> = new Array<IRteListButtonItem>();
  confimrButton: IRteListButtonItem;
  cancelButton: IRteListButtonItem;

  constructor(public dialogRef: RteDialogRef<UploadedValuesConfirmDialogComponent>,
    private alert: RTEAlertService,
    @Inject(MAT_DIALOG_DATA) public data: UploadedValuesConfirmConfig,
    ) { }

  ngOnInit() {
    this.selected = new UploadValuesConfirmed();

    this.selected.Value = this.data.Value;

    if (this.data.Schemas.length === 1) {
      this.selected.Schema = this.data.Schemas[0];
    }

    this.configureListButtons();
  }

  configureListButtons() {

    this.cancelButton = {
      description: 'Cancelar',
      disabled: false,
      click: () => {
        this.dialogRef.close();
      }
    };

    this.confimrButton = {
      description: 'Confirmar',
      disabled: false,
      click: () => {
        if (this.validateForm()) {
          this.dialogRef.close(this.selected);
        }
      }
    };

    this.listButtons.push(this.cancelButton);
    this.listButtons.push(this.confimrButton);
  }

  cancel() {
    this.dialogRef.close();
  }

  confirm() {
    if (this.validateForm()) {
      this.dialogRef.close(this.selected);
    }
  }

  validateForm(): boolean {
    let validation = '';

    if (this.selected.Value == null || this.selected.Value === '') {
      validation = 'Não há valores para vínculo no campo';
    }

    if (this.selected.Schema == null) {
      validation = 'Por favor, escolha um filtro para aplicar os valores importados';
    }

    if (validation !== '') {
      this.alert.warning('Por favor, verifique os campos', validation, {expanded: true});
      return false;
    }

    return true;
  }
}


